import React from 'react';
import { Alert, Button } from 'antd';

/** A failed read is different from an empty catalogue. Retry only on request. */
const LoadFailure: React.FC<{ subject: string; onRetry: () => void }> = ({
  subject,
  onRetry,
}) => (
  <Alert
    type="error"
    showIcon
    title={`${subject} could not be loaded.`}
    action={<Button onClick={onRetry}>Retry</Button>}
  />
);

export default LoadFailure;
